module.exports = __webpack_public_path__ + "img/download-app-button.c33a3fe7.png";